
export default {
    init() {
        this.changeWeek();
        this.aprove();
        this.totalRow();
        this.bonus();
        this.total();
    },

    changeWeek() {
        let $this = this;
        $('body').on('change', '#week', function(e) {
            e.preventDefault();
            $this.reloadTable();
        });
    },
    reloadTable() {
        $.ajax({
            type: 'GET',
            url: '/payroll',
            data: ({
                week: $('#week').val(),
            }),
            success: function (response) {
                $('#payroll_table').html(response);
            },
        });
    },
    totalRow(row) {
        let pay = parseFloat($(row).find('.pay').val());
        if (isNaN(pay)) {
            pay = 0;
        }
        let bonus = parseFloat($(row).find('.bonus').val());
        if (isNaN(bonus)) {
            bonus = 0;
        }
        let penalty = parseFloat($(row).find('.penalty').val());
        if (isNaN(penalty)) {
            penalty = 0;
        }
        let total = pay;
        total += bonus;
        total -= penalty;
        $(row).find('.total').text(total.toFixed(2));
    },
    total() {
        let sum = 0;
        $('.total').each(function(i, el){
            let t = parseFloat($(el).text());
            if (isNaN(t)) {
                t = 0;
            }
            sum += t;
        });
        $('#total').text(sum.toFixed(2));
    },
    bonus() {
        let $this = this;
        $('body').on('keyup', '.send_input', function(e) {
            e.preventDefault();
            let send_input = '';
            if ($(this).hasClass('pay')) {
                send_input = 'pay';
            }
            if ($(this).hasClass('bonus')) {
                send_input = 'bonus';
            }
            if ($(this).hasClass('penalty')) {
                send_input = 'penalty';
            }
            let send_input_val = parseFloat($(this).val());
            if (isNaN(send_input_val)) {
                send_input_val = 0;
            }
            $(this.closest('tr')).find('.driver_checkbox').prop('checked', true);
            $this.totalRow(this.closest('tr'));
            $this.total()
           /* $.ajax({
                type: 'POST',
                url: '/payroll/' + send_input,
                data: ({
                    worker_id: this.closest('tr').id,
                    start_week_date: $('#week :checked').val(),
                    send_input: send_input,
                    send_input_val: send_input_val,
                }),
                success: function () {
                    $this.total();
                },
            });*/

        });
    },
    aprove() {
        let $this = this;
        $('body').on('click', '#aprove', function(e) {
            e.preventDefault();
            let checked = $('.worker_checkbox:checked');
            let workers = new Object();
            checked.each(function (i, el) {
                let worker = $(el).closest('tr')[0];
                let pay = parseFloat($(worker).find('.pay').val());
                if (isNaN(pay)) {
                    pay = 0;
                }
                let bonus = parseFloat($(worker).find('.bonus').val());
                if (isNaN(bonus)) {
                    bonus = 0;
                }
                let penalty = parseFloat($(worker).find('.penalty').val());
                if (isNaN(penalty)) {
                    penalty = 0;
                }
                workers[worker.id] = {
                    worker_id: worker.id,
                    start_week: $('#week').val(),
                    hours: $(worker).find('.hours').text(),
                    salary: $(worker).find('.salary').text(),
                    pay: pay,
                    bonus: bonus,
                    penalty: penalty,
                    total: $(worker).find('.total').text()
                };
            });

            $.ajax({
                type: 'POST',
                url: '/payroll/aprove',
                data: {workers},
                success: function (response) {
                    let arr = ['.pay', '.bonus', '.penalty'];
                    //$('#modal_aprove').modal('show');
                    $('#success-action-modal').modal('show');
                    response.workers.forEach(function(id) {
                        $('#'+id).find('.check_svg').removeClass('d-none');
                        $('#'+id).find('.checkbox').addClass('d-none');

                        arr.forEach(function (element) {
                            let input_val =  $('#'+id).find(element).val();
                            if (! input_val) {
                                input_val = 0;
                            }
                            $('#'+id).find(element +'_outer').text('$' + input_val);
                        });
                    });
                },
            });
        });
    },
}
